import { ColumnDef } from '@tanstack/react-table';
import AdvanceTable from 'components/base/AdvanceTable';
import { currencyFormat, formatDate, PF } from 'helpers/utils';
import useAdvanceTable from 'hooks/useAdvanceTable';
import AdvanceTableProvider from 'providers/AdvanceTableProvider';
import { Link } from 'react-router-dom';
import AdvanceTableFooter from 'components/base/AdvanceTableFooter';
import { useEffect, useState } from 'react';
import { BrandProducts } from 'api/categories/_requests';

const EcomBrandListProductTable = ({
  productsData
}: {
  productsData?: BrandProducts[];
}) => {
  const columns: ColumnDef<BrandProducts>[] = [
    {
      id: 'productImage',
      accessorKey: '',
      cell: ({ row: { original } }) => {
        const { thumbnail } = original;
        return (
          <div className="rounded-2 border border-translucent d-inline-block">
            <img
              src={thumbnail}
              alt="product"
              width={53}
              className="image-square"
            />
          </div>
        );
      },
      meta: {
        cellProps: { className: 'py-0' },
        headerProps: { style: { width: '7%' } }
      }
    },
    {
      accessorKey: 'product',
      header: 'Products',
      cell: ({ row: { original } }) => {
        const { name } = original;
        return (
          <Link
            to={`/product-details/${original.slug}`}
            className="fw-semibold line-clamp-1"
          >
            {name}
          </Link>
        );
      },
      meta: {
        headerProps: { style: { minWidth: 250, width: '30%' } },
        cellProps: { className: 'pe-11' }
      }
    },
    {
      accessorKey: 'price',
      header: () => 'Price',
      cell: ({ row: { original } }) =>
        currencyFormat(original.price, {
          currency: 'SAR',
          style: 'currency'
        }),
      meta: {
        headerProps: { style: { width: '10%' }, className: 'text-end' },
        cellProps: { className: 'text-end fw-semibold' }
      }
    }
  ];

  const table = useAdvanceTable({
    data: productsData ?? [],
    columns,
    pageSize: 5,
    pagination: true,
    sortable: true
  });

  return (
    <div>
      <AdvanceTableProvider {...table}>
        <div className="border-y border-translucent">
          <AdvanceTable tableProps={{ className: 'phoenix-table fs-9' }} />
          <AdvanceTableFooter pagination />
        </div>
      </AdvanceTableProvider>
    </div>
  );
};

export default EcomBrandListProductTable;
